import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DocumentModel } from 'src/app/models/document.model';
import { PortalService } from 'src/app/services/portal.service';
import { SendDocumentDialogComponent } from '../send-document-dialog/send-document-dialog.component';
import { DialogService } from 'src/app/services/dialog.service';
import { PortalSendModel } from 'src/app/models/portal-send.model';
import { catchError, take } from 'rxjs';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'tx-pdf-saved-dialog',
  templateUrl: './pdf-saved-dialog.component.html',
  styleUrls: ['./pdf-saved-dialog.component.scss'],
})
export class PdfSavedDialogComponent implements OnInit {
  @Input() document: DocumentModel;
  public portalAvailable = false;
  public uploadedPortalFiles: string[] = [];
  constructor(
    private portalService: PortalService,
    private dialogService: DialogService,
    public activeModal: NgbActiveModal
  ) {
    this.document = {
      isActiveDocument: false,
      saveAsPdf: false,
      answersChanged: false,
      openInAnotherSession: false,
      pdfAnswersChanged: false,
      txdocsAnswersChanged: false,
    };
  }

  ngOnInit(): void {
    this.init();
  }

  private init() {
    if (this.document.document && this.document.filename) {
      const element = document.getElementById('downloadLink') as HTMLElement;

      if (element) {
        element.setAttribute('href', 'data:application/octet-stream;base64,' + this.document.document);
        element.setAttribute('download', this.document.filename);
      }

      this.getPortalServices();
    }
  }

  private getPortalServices() {
    if (!this.document) {
      return;
    }

    this.portalService.getServices(this.document).subscribe((res: any) => {
      //Editor API just responds true/false if the service exists by CaseGUID
      //FUTURE FEATURE #### Editor API will call OI API in an attempt to create internal service for DOCx functionality once when none are found by CaseGUID
      if (res.available === true) {
        this.portalAvailable = true;
        this.uploadedPortalFiles = res.existingFiles;
      } else {
        this.portalAvailable = false;
        this.uploadedPortalFiles = [];
      }
    });
  }

  onSendToPortalClicked() {
    if (!this.portalAvailable) {
      return;
    }

    const modalRef = this.dialogService.openCustomDialog('sendDocument', SendDocumentDialogComponent, {
      size: 'md',
      backdrop: 'static',
    });
    const modalInstance = modalRef.componentInstance;
    modalInstance.fileName = this.document.filename ?? '';
    modalInstance.caseName = this.document.casDescription ?? '';
    modalInstance.clientName = this.document.ctcFirstName + ' ' + this.document.ctcLastName;
    modalInstance.existingFiles = this.uploadedPortalFiles;

    modalRef.result.then((res) => {
      let sendModel = {
        ...this.document,
        description: modalInstance.description,
        filename: modalInstance.fileName,
        targetType: modalInstance.extension.extension,
      } as PortalSendModel;

      this.portalService
        .sendDocument(sendModel)
        .pipe(
          take(1),
          catchError((err: any) => {
            console.log(err);
            // this.loading = false;
            if (err.httpStatusCode == 409) {
              this.dialogService.info({
                title: `Existing Filename`,
                message: `The file name "${err.fileName}" has already been uploaded.  Please try again.`,
              });
            } else {
              this.dialogService.info({
                title: `Trouble sending file`,
                message: `There was a problem sending the file named "${err.fileName}".  Please try again.`,
              });
            }
            throw err;
          })
        )
        .subscribe((res) => {
          this.dialogService.info({
            title: `Document Sent Successfully`,
            message: `The document has been sent to the client.`,
          });
        });
    });
  }
}
